import { ReactComponentOrElement, useIonModal } from '@ionic/react';
import { useState } from 'react';

export interface ModalProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onDismiss: (arg: any) => void;
  centered?: boolean;
  backdropDismiss?: boolean;
  modalInModal?: boolean;
  useCanDismiss?: boolean;
  managed?: boolean;
}

export default function useModal(modal: ReactComponentOrElement) {
  const [isPresent, setIsPresent] = useState(false);
  const [props, setProps] = useState({});
  const [present, dismiss] = useIonModal(modal, props);

  const presentModal = <T extends ModalProps>(newProps?: T) => {
    const {
      onDismiss: handleDismiss,
      backdropDismiss,
      centered,
      modalInModal,
      useCanDismiss,
      managed,
      ...restProps
    } = newProps || {};
    setIsPresent(true);
    if (!isPresent) {
      setProps(() => ({
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onDismiss: (arg: any) => {
          if (handleDismiss) handleDismiss(arg);
          dismiss();
        },
        ...restProps,
      }));

      present({
        initialBreakpoint: 1,
        breakpoints: useCanDismiss ? [0, 1] : [1, 0.5, 0],
        cssClass: `${managed ? 'auto-height-modal-managed' : 'auto-height-modal '} ${centered ? 'centered-modal' : ''}${modalInModal ? 'mini-modal' : ''} `,
        backdropDismiss,
        canDismiss: async (data, role) => {
          // permite el cierre por defecto
          if (!useCanDismiss) {
            setIsPresent(false);
            // handleDismiss(null);
            return true;
          }
          if (useCanDismiss) {
            // Si handleDismiss está definido y el cierre es por fondo o gesto
            if (handleDismiss && (role === 'backdrop' || role === 'gesture')) {
              handleDismiss(null);
              return false; // Evita que el modal se cierre
            }
          }

          // Permite el cierre en otros casos
          return true;
        },
        onDidDismiss: (event) => {
          setIsPresent(false);
          if (handleDismiss && (event.detail.role === 'backdrop' || event.detail.role === 'gesture')) {
            handleDismiss(null);
          }
        },
      });
    }
  };

  return { presentModal, isPresent, dismissModal: dismiss };
}
